/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import { useLocalization as m } from "@progress/kendo-react-intl";
import { clear as t, messages as i } from "../messages/index.mjs";
import { useUnstyled as u, classNames as p, uDropDownsBase as f, IconWrap as d } from "@progress/kendo-react-common";
import { xIcon as D } from "@progress/kendo-svg-icons";
const b = (n) => {
  const a = m(), o = u(), s = o && o.uDropDownsBase, r = a.toLanguageString(t, i[t]), c = (l) => l.preventDefault();
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: p(f.clearButton({ c: s })),
      role: "button",
      onClick: n.onClick,
      onMouseDown: c,
      tabIndex: -1,
      title: r,
      key: "clearbutton"
    },
    /* @__PURE__ */ e.createElement(d, { name: "x", icon: D })
  );
};
export {
  b as default
};
